/**
 * SWISS School Portal - Entry Point
 * ==================================
 * Main entry point for the React application.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the push service worker (public/sw.js). It only receives
// Web Push for anonymous-report alerts — no offline caching — so
// registering it eagerly is cheap and lets an admin opt into alerts
// without a page reload. Failures are non-fatal.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => {
      console.warn('[sw] registration failed', e?.message);
    });
  });
}
